import React, { useState, useEffect } from "react";
import ThumbsUp from "../assets/images/neurapulse/ThumbsUp.svg?react";
import ExclaimationCircle from "../assets/images/neurapulse/exclamation-circle.svg?react";
import ExceleRATELogo from "../assets/report_images/excelerate-logo.png";
import { Spin } from "antd";
import { ErrorCodes } from "./components/ErrorCodes";

interface INeurapulseData {
	// Define the structure of the data you expect from the API
	webId: string;
	nonce: string;
}

const NeurapulsePage: React.FC = () => {
	const [loading, setLoading] = useState<boolean>(true);
	const [error, setError] = useState<string | null>(null);
	const [errorCode, setErrorCode] = useState<ErrorCodes | null>(null);

	useEffect(() => {
		const storeData = async (webId: string, nonce: string) => {
			try {
				const neurapulseData: INeurapulseData = {
					webId: webId,
					nonce: nonce,
				};
				if (!process.env.REACT_APP_PUBLIC_API_URI)
					throw new Error("API URI not set");
				const baseURL = new URL(
					process.env.REACT_APP_PUBLIC_API_URI,
					window.location.origin
				).href;

				const response = await fetch(`${baseURL}/Neurapulse/update`, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(neurapulseData),
				});
				const result = await response.json();

				if (!response.ok) {
					const errMsge = "Failed to sync with ExceleRATE";

					if (response.status === 400) {
						if (result.detail === ErrorCodes.INVALID_NONCE) {
							setErrorCode(ErrorCodes.INVALID_NONCE);
						}
					}

					setError(errMsge);
				}

				setLoading(false);
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		};

		// Fetch URL search params
		const params = new URLSearchParams(window.location.search);
		const webId = params.get("web_id");
		const nonce = params.get("nonce");

		if (webId && nonce) {
			storeData(webId, nonce);
		} else {
			setError("Failed to initialize");
			setErrorCode(ErrorCodes.INVALID_PARAMS);
			setLoading(false);
		}
	}, []);

	const getLoadingGui = () => {
		return (
			<div
				style={{
					padding: "20px",
					marginTop: "230px",
					textAlign: "center",
					flexDirection: "column",
					alignItems: "center",
				}}
			>
				<Spin size="large" />
			</div>
		);
	};

	const getResultGui = () => {
		return (
			<div
				style={{
					padding: "20px",
					textAlign: "center",
					flexDirection: "column",
					display: "flex",
					alignItems: "center",
					marginTop: "125px",
				}}
			>
				<>
					{error ? (
						<>
							<ExclaimationCircle style={{ width: "150px", height: "150px" }} />
							<h1 style={{ marginTop: "50px", fontWeight: "bold" }}>
								Error Syncing Data
							</h1>
							<div style={{ marginTop: "20px", fontSize: "20px" }}>
								<div>{error}</div>
								<div style={{ fontWeight: "lighter" }}>{errorCode}</div>
							</div>
						</>
					) : (
						<>
							<ThumbsUp style={{ width: "150px", height: "150px" }} />
							<h1 style={{ marginTop: "50px", fontWeight: "bold" }}>
								All Done
							</h1>
							<div style={{ marginTop: "20px", fontSize: "24px" }}>
								You can close this window
							</div>
						</>
					)}
				</>
			</div>
		);
	};

	return (
		<>
			<img
				src={ExceleRATELogo}
				alt="ExceleRATE Logo"
				style={{ width: "200px" }}
			/>
			{loading ? getLoadingGui() : getResultGui()}
		</>
	);
};

export default NeurapulsePage;
